import { render, staticRenderFns } from "./candidate_gender_age.vue?vue&type=template&id=373c6abf&scoped=true&"
import script from "./candidate_gender_age.vue?vue&type=script&lang=js&"
export * from "./candidate_gender_age.vue?vue&type=script&lang=js&"
import style0 from "./candidate_gender_age.vue?vue&type=style&index=0&id=373c6abf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "373c6abf",
  null
  
)

export default component.exports